




























import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop, Emit } from "vue-property-decorator";
import { EventType } from "@/models/event";
import { EventTypeIcon } from "./EventTypeIcon.vue";

@Component({
  components: {
    EventTypeIcon
  }
})
export class EventTypeSelectionCard extends Vue {
  @Model("change")
  @Prop({ default: [] })
  readonly value!: EventType[];
  private selected: EventType[] = [];

  get availableEventTypes() {
    return Object.values(EventType)
      .filter((value) => value != EventType.Visit) // Fallback compatibility
      .map((value): { label: string; value: string } => ({
        label: this.$t(`event.values.eventType.${value}`) as string,
        value
      }));
      // .sort((a, b) => a.label.localeCompare(b.label));
  }

  mounted() {
    this.selected = [...(this.value || [])];
  }

  isSelected(type: EventType) {
    return this.selected.includes(type);
  }

  onClick(type: EventType) {
    if (this.isSelected(type)) {
      this.onDeselect(type);
    } else {
      this.onSelect(type);
    }
  }

  @Emit("select")
  onSelect(type: EventType) {
    this.onChange([...this.selected, type]);
  }

  @Emit("deselect")
  onDeselect(type: EventType) {
    this.onChange(this.selected.filter(el => el !== type));
  }

  @Emit("change")
  onChange(value: EventType[]) {
    this.selected = value;
  }
}

export default EventTypeSelectionCard;
